L.Title = L.Class.extend({
    includes: L.Mixin.Events,

    options: {
        text: "",
    },

    initialize: function (options) {
        L.Util.setOptions(this, options);
    },

    addTo: function (map) {
        this.map = map;
        this._create();
        
        return this;
    },

    remove: function () {
        if (this._container.parentNode) {
            this._container.parentNode.removeChild(this._container);
        }
    },
    
    setTitle: function (text) {
        this._text.textContent = text;
    }, 

    _create: function () {
        if (!!this._container)
            return;

        this._container = L.DomUtil.create("div", "leaflet-title-container", this.map._controlContainer);
        this._text = L.DomUtil.create("h1", "leaflet-title", this._container);
        this.setTitle('' + this.options.text);
    }
});

L.title = function (options) {
    return new L.Title(options);
}
;
define("leaflet-title", function(){});

